// src/components/ProtectedRoute.js
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../metodos/AuthContext'; // Make sure this path is correct

//GENERADO VERIFICADO CON IA
const ProtectedRoute = () => {
  const { currentUser, currentUserData, loading, error } = useAuth();
  
  useEffect(() => {
  }, [loading, currentUser, error, currentUserData]);

  // If there's a Firebase user but we had a network error getting additional data,
  // we can still proceed with basic authentication
  const hasNetworkError = error && error.includes("Network Error");
  const isAuthenticated = currentUser !== null;

  // Only show loading when we're actually still loading
  // (not when we have a user but couldn't fetch their data)
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
        <p className="ml-4">Cargando...</p>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    console.log("Usuario no autenticado, mandar pal login");
    return <Navigate to="/login" replace />;
  }

  // If authenticated but have network error, show warning but proceed
  if (hasNetworkError) {
    console.log("Error al conectar con firebase autentication, error de intener");
    // You could show a notification or toast here about the network issue
    // but still allow the user to proceed to the protected content
  }

  // User is authenticated, render the protected content
  console.log("Usuario autenticado, mostrar contenido protegido");
  return <Outlet />;
};

export default ProtectedRoute;